if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButtonText.classList.remove('hidden');
          this.submitButton.querySelector('.sold-out-message')?.classList.add('hidden');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      connectedCallback() {
        this.emailInput = this.querySelector('input[type="email"]');
        this.variantInput = this.querySelector('[data-back-in-stock-variant]');
        this.productInput = this.querySelector('[data-back-in-stock-product]');
        this.message = this.querySelector('[data-back-in-stock-message]');
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        this.toggle(this.dataset.initialAvailable !== 'true');
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;

        if (!variant) {
          this.toggle(false);
          return;
        }

        this.toggle(!variant.available);

        const variantTitle = this.variantDisplayName(variant);

        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.productInput) {
          this.productInput.value = variantTitle ? `${this.dataset.productTitle} - ${variantTitle}` : this.dataset.productTitle;
        }
        if (this.message) this.message.textContent = this.messageText(variantTitle);
      }

      variantDisplayName(variant) {
        const title = `${variant?.public_title || variant?.title || ''}`.trim();
        return title && title !== 'Default Title' ? title : '';
      }

      messageText(variantTitle) {
        return variantTitle
          ? `Laissez votre email pour être prévenu quand ${variantTitle} revient en stock.`
          : 'Laissez votre email pour être prévenu quand ce produit revient en stock.';
      }

      toggle(show) {
        this.classList.toggle('hidden', !show);
        if (this.emailInput) this.emailInput.disabled = !show;
      }
    }
  );
}

if (!customElements.get('shrink-helper')) {
  customElements.define(
    'shrink-helper',
    class ShrinkHelper extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-shrink-helper-item]'));
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        const mode = this.variantShrinkMode(variant);

        this.classList.toggle('hidden', !mode);
        this.items.forEach((item) => {
          item.classList.toggle('hidden', item.dataset.shrinkMode !== mode);
        });
      }

      variantShrinkMode(variant) {
        const label = [variant?.public_title, variant?.title, ...(variant?.options || [])]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        if (label.includes('no shrink') || label.includes('no-shrink') || label.includes('no_shrink') || label.includes('noshrink')) return 'no-shrink';
        if (label.includes('shrink')) return 'shrink';

        return '';
      }
    }
  );
}

if (!customElements.get('mobile-sticky-atc')) {
  customElements.define(
    'mobile-sticky-atc',
    class MobileStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.price = this.querySelector('[data-sticky-atc-price]');
        this.variant = this.querySelector('[data-sticky-atc-variant]');
        this.stock = this.querySelector('[data-sticky-atc-stock]');

        this.button?.addEventListener('click', () => {
          if (!this.mainButton || this.mainButton.disabled) return;
          this.mainButton.click();
        });

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        this.observeMainButton();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.observer?.disconnect();
      }

      observeMainButton() {
        if (!this.mainButton) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            const shouldShow = window.matchMedia('(max-width: 749px)').matches && !entry.isIntersecting;
            this.classList.toggle('is-visible', shouldShow);
            this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          },
          { threshold: 0 }
        );

        this.observer.observe(this.mainButton);
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant) return;

        if (this.variant) this.variant.textContent = variant.public_title || variant.title || '';
        if (this.stock) this.stock.textContent = variant.available ? 'En stock' : 'Épuisé';
        if (this.button) this.button.disabled = !variant.available;

        window.requestAnimationFrame(() => {
          const priceNode = document.querySelector(`#price-${this.sectionId} .price-item--sale, #price-${this.sectionId} .price-item--regular`);
          if (priceNode && this.price) this.price.textContent = priceNode.textContent.trim();
        });
      }
    }
  );
}
